import { setLocalStorage } from './browserStorageHandler';
import { COMBOOFFER_PAGE } from './constants/ApiConstants';
import { OFFER_PATH } from './constants/localStorageConstants';

const getComboOfferPath = (contentId: string) => {
  let comboOfferPath = '';
  if (contentId) {
    comboOfferPath = COMBOOFFER_PAGE.replace(':offerName', contentId);
    setLocalStorage(OFFER_PATH, comboOfferPath);
  }
  return comboOfferPath;
};

export default getComboOfferPath;
